const CustomerVehiclePlateCode = {
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  K: "K",
  M: "M",
  N: "N",
  P: "P",
  R: "R",
  S: "S",
  T: "T",
  V: "V",
  X: "X",
  NUM_1: "1",
  NUM_4: "4",
  NUM_5: "5",
  NUM_6: "6",
  NUM_7: "7",
  NUM_8: "8",
  NUM_9: "9",
  NUM_10: "10",
  NUM_11: "11",
  NUM_12: "12",
  NUM_13: "13",
  NUM_14: "14",
  NUM_15: "15",
  NUM_16: "16",
  NUM_17: "17",
  NUM_18: "18",
  NUM_19: "19",
  NUM_20: "20",
}
export default CustomerVehiclePlateCode;